export const PATCH_USER_SERVICES_SUCCESS = 'PATCH_USER_SERVICES_SUCCESS';
export const PATCH_USER_SERVICES_ERROR = 'PATCH_USER_SERVICES_ERROR';

export const GET_USER_SERVICES_SUCCESS = 'GET_USER_SERVICES_SUCCESS';
